<div class="navigation-tagged-link">
  <itc-navigation-link
    [id]="id()"
    [iconClass]="iconClass()"
    [linkName]="linkName()"
    [showIcon]="showIcon()"
    [isTooltipEnabled]="isTooltipEnabled()"
    [topNavigation]="topNavigation()"
  >
    @if (!isTooltipEnabled()) {
      @let defaultTagTextTranslationKey = 'navigation.tags.new';

      <kds-tag size="small" [colorVariant]="tagColorVariant() || 'subtle-new'">
        {{ tagTextTranslationKey() || defaultTagTextTranslationKey | translate }}
      </kds-tag>
    }
  </itc-navigation-link>
</div>
